export default "__VITE_ASSET__DPArYxG6__"